module.exports = __webpack_public_path__ + "img/VGT.1792c2f0.png";